/**
 * Where the API is.
 *
 * The browser always talks to the API directly, at its own address: nothing
 * proxies `/api`, neither Vite locally nor nginx when deployed. Fixed at build
 * time — each environment's image is built with its own — and locally the API
 * is always published on the host's 12100 (Docker or not).
 */
export const config = {
  apiOrigin: (import.meta.env.VITE_API_ORIGIN || 'http://localhost:12100').replace(/\/+$/, ''),
  apiPrefix: '/api',
} as const;

export function apiUrl(path: string): string {
  return `${config.apiOrigin}${config.apiPrefix}${path}`;
}
